import React from "react";
import { Header } from "../components/Header";
import { MatchCenter } from "../components/MatchCenter";
import { Footer } from "../components/Footer";

export default function StatsPage() {
  return (
    <div className="min-h-screen bg-[var(--page-bg)] text-[var(--brand-ink)]" data-testid="page-stats">
      <Header />
      <MatchCenter />
      <Footer />
    </div>
  );
}
